import { defineStore } from "pinia"

export const useVehicleTypesStore = defineStore("vehicleTypes", {
  state: () => ({
    vehicleTypes: [],
    isLoading: false,
    error: null,
  }),

  getters: {
    activeVehicleTypes: (state) => state.vehicleTypes.filter((type) => type.status === 'active'),
    cityxpressVehicleTypes: (state) =>
      state.vehicleTypes
        .filter((type) => type.status === 'active' && type.for_cityxpress)
        .sort((a, b) => (a.order ?? 999) - (b.order ?? 999)),
    getVehicleTypeById: (state) => (id) => state.vehicleTypes.find((type) => type.id === id),
    getVehicleTypeByCode: (state) => (code) => state.vehicleTypes.find((type) => type.code === code),
  },

  actions: {
    async fetchVehicleTypes(activeOnly = false) {
      this.isLoading = true
      this.error = null
      try {
        await this.$axios.get("/sanctum/csrf-cookie")

        const response = await this.$axios.get("/api/v1/fleet/vehicle-types", {
          params: { active_only: activeOnly },
        })

        this.vehicleTypes = response.data.data
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to fetch vehicle types"
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async createVehicleType(vehicleTypeData) {
      this.isLoading = true
      this.error = null
      try {
        await this.$axios.get("/sanctum/csrf-cookie")

        const response = await this.$axios.post("/api/v1/fleet/vehicle-types", vehicleTypeData)

        this.vehicleTypes.push(response.data.data)
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to create vehicle type"
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async updateVehicleType(id, vehicleTypeData) {
      this.isLoading = true
      this.error = null
      try {
        await this.$axios.get("/sanctum/csrf-cookie")

        const response = await this.$axios.put(`/api/v1/fleet/vehicle-types/${id}`, vehicleTypeData)

        const index = this.vehicleTypes.findIndex((type) => type.id === id)
        if (index !== -1) {
          this.vehicleTypes[index] = response.data.data
        }
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to update vehicle type"
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async deleteVehicleType(id) {
      this.isLoading = true
      this.error = null
      try {
        await this.$axios.get("/sanctum/csrf-cookie")

        await this.$axios.delete(`/api/v1/fleet/vehicle-types/${id}`)

        this.vehicleTypes = this.vehicleTypes.filter((type) => type.id !== id)
        return { success: true }
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to delete vehicle type"
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async toggleVehicleTypeStatus(id) {
      this.isLoading = true
      this.error = null
      try {
        await this.$axios.get("/sanctum/csrf-cookie")

        const response = await this.$axios.patch(`/api/v1/fleet/vehicle-types/${id}/toggle-status`)

        const index = this.vehicleTypes.findIndex((type) => type.id === id)
        if (index !== -1) {
          this.vehicleTypes[index] = response.data.data
        }
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || "Failed to toggle vehicle type status"
        throw error
      } finally {
        this.isLoading = false
      }
    },
  },
})

